<section class="pick-camera-result">
  <h2 class="purpose">
    {{ request()?.purpose || ('COMMON.SELECT_CAMERA' | translate) }}
  </h2>

  <div class="selector">
    <camera-picker-inline
      [options]="pickerOptions()"
      [selectedValue]="selectedValue"
      (onSave)="onCameraSelected($event)"
    ></camera-picker-inline>
  </div>

  @if (request()?.multi) {
    <footer class="actions">
      <ui-button
        type="secondary"
        size="s"
        [text]="'COMMON.SKIP_NO_CAMERAS' | translate"
        (clickAction)="skipCameras()"
      ></ui-button>
      <ui-button
        type="primary"
        size="s"
        [text]="'COMMON.DONE' | translate"
        (clickAction)="saveCameras()"
      ></ui-button>
    </footer>
  }
</section>
